import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { map, Observable } from 'rxjs';
import { ODataRequest } from '../utilities/sdk-base/o-data-request';
import { PagingResponse } from '@models/paging-response.model';
import { BuiltInFieldResource } from '../models/resource/built-in-field.resource';

@Injectable({ providedIn: 'root' })
export class BuiltInFieldSdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public get(): Observable<{ databaseTitle: string, displayTitle: string }[]> {
		const request = new ODataRequest('get', 'builtinfields');
		return this.makeODataRequest$<PagingResponse<BuiltInFieldResource>>(request, 'api2').pipe(
			map((response) => {
				return response.value.map((item) => ({databaseTitle: item.databaseTitle, displayTitle: item.displayTitle}))
			})
		);
	}

	public getCaseAssessmentFields(): Observable<{ name: string, id: string }[]> {
		const request = new ODataRequest('get', 'builtinfields');
		request.$filter<BuiltInFieldResource>([{
			operation: 'equals',
			column: 'isPartOfCaseAssessment',
			value: true
		}]);
		return this.makeODataRequest$<PagingResponse<BuiltInFieldResource>>(request, 'api2').pipe(
			map((response) => {
				return response.value.map((item) => ({name: item.displayTitle, id: item.fieldId}))
			})
		);
	}
}
